import { FC, JSX, ReactNode } from "react";

import { OrString } from "config/types";

import classNames from "classnames";
import { defaultTo } from "lodash-es";

import replaceString from "../../utils/replaceString";

interface IProps {
  text: string;
  target: OrString<RegExp>;
  className?: string;
  replacementValue?: ReactNode;
  replacementElement?: keyof JSX.IntrinsicElements;
}

const VariableText: FC<IProps> = props => {
  const { text, target, className, replacementValue, replacementElement } = props;
  const targetMatch = defaultTo(target, /@(\w+)@/g);

  const classes = classNames("variable-text_tag", className);

  const Element = replacementElement || "span";

  const content = replaceString(text, targetMatch, (match, i) => {
    return (
      <Element key={i} className={classes}>
        {replacementValue || match}
      </Element>
    );
  });

  return <>{content}</>;
};

export default VariableText;
